import { Stack, SxProps, Theme, Typography } from '@mui/material';

import { DirectMailSenderProfile } from 'domains/content/types';
import HtmlRenderer from 'domains/core/components/HtmlRenderer';

import ContentPreview from '../ContentPreview/ContentPreview';

export type Props = {
    isOpen: boolean;
    onClose: () => void;
    htmlContent?: string;
    isCloseEnabled?: boolean;
    isGridItem?: boolean;
    selectedLink?: string;
    sx?: SxProps<Theme>;
    directMailSender?: DirectMailSenderProfile;
    previewLabel?: string;
};

const DirectMailPreviewContent = ({
    htmlContent = '',
    isCloseEnabled = true,
    isGridItem = false,
    isOpen,
    onClose,
    selectedLink,
    sx,
    directMailSender,
    previewLabel = 'direct mail preview',
}: Props) => (
    <ContentPreview
        isOpen={isOpen}
        isCloseEnabled={isCloseEnabled}
        isGridItem={isGridItem}
        onClose={onClose}
        sx={sx}
        previewLabel={previewLabel}
    >
        <Stack height="100%" overflow="hidden">
            {directMailSender && (
                <Stack spacing={0.5} px={3} py={2} minHeight={112}>
                    <Typography variant="body2">
                        {directMailSender.firstName && directMailSender.lastName
                            ? `${directMailSender.firstName} ${directMailSender.lastName}`
                            : directMailSender.name ?? ''}
                        {directMailSender.companyName ? ` - ${directMailSender.companyName}` : ''}
                    </Typography>

                    <Typography variant="body2">
                        {directMailSender.streetAddress ?? ''}
                        {directMailSender.streetAddress2 ? `, ${directMailSender.streetAddress2}` : ''}
                    </Typography>

                    <Typography variant="body2">
                        {[directMailSender.city, directMailSender.stateCode].filter(Boolean).join(', ')}
                        {directMailSender.zipCode ? ` ${directMailSender.zipCode}` : ''}
                    </Typography>
                </Stack>
            )}

            <Stack height="100%">
                <HtmlRenderer htmlContent={htmlContent} selectedLink={selectedLink} useIframe={true} />
            </Stack>
        </Stack>
    </ContentPreview>
);

export default DirectMailPreviewContent;
